export const getActivePromotion = () => {
  const currentDate = new Date();
  const promotionConfig = {
    isActive: false,
    title: "HAPPY EASTER!",
    description: "11% OFF All Tests & Packages with code",
    promoCode: "EASTER25",
    discountPercentage: 11,
    landingPagePath: "lab-test-list/tests",
    startDate: new Date(currentDate.getFullYear(), 3, 7),
    endDate: new Date(currentDate.getFullYear(), 3, 30),
    packageType: "all",
  };

  promotionConfig.isActive =
    currentDate >= promotionConfig.startDate &&
    currentDate <= promotionConfig.endDate;

  return promotionConfig;
};
